import { ShotType, ShotSelection, PracticeShot, ShotHistory } from './ShotSelection';
import * as GrindLookup from '../library/GrindLookup';
import { PipaConsentValue } from './PipaConsent';

export type PreferenceHand = 'right' | 'left' | '';
export type PreferenceHandicap = '0 or Less' | '1-5' | '6-10' | '11-15' | '16-20' | '20+' | '';
export type PreferenceConditions = 'Soft' | 'Slightly Soft' | 'Medium' | 'Slightly Firm' | 'Firm' | '';
export type PreferenceConfidence = 'Low' | 'Less' | 'Medium' | 'More' | 'High' | '';
export type Loft = '43' | '44' | '45' | '46' | '47' | '48' | '50' | '52' | '54' | '56' | '58' | '60' | '62' | '';
export type ShotFittingStatus = 'open' | 'closed' | 'active';  //open = waiting for shot, closed = shot done, active = current shot being taken
export type OrderStatus = 'incomplete' | 'sent' | 'queued' | 'error' | '';


//
export class LoftShots {
    constructor(public lineNumber: number, public loft: Loft, public shots: ShotSelection[]) { }
}

//
export class ShotsForFitting {
    constructor(public loft: Loft, public shotType: ShotType, public statuses: ShotFittingStatus[] = []) {
    }
}

export class LoftForFitting {
    constructor(public lineNumber: number, public loft: Loft, public shotType: ShotType, public practiceShots: PracticeShot[] = []) {
        const shotName = () => {
            return loft + " " + shotType;
        }
    }
}

export class EnhancedFittingData {
    constructor(public id = "", 
    public datetime = new Date().toISOString(), 
    public isDeleted = "false", 
    public loft = "", 
    public shotType = "", 
    public attackAngle = "", 
    public shaftLean = "", 
    public ballSpeed = "",
    public launchAngle = "", 
    public recommendations = new Array<GrindLookup.LoftGrindRecommendation>(),
    public message = ""){}
}

export type ShaftLeanStatus = "available" | "unavailable" | "unknown";


export default class Golfer {
    id = 0;
    vwfSession = "";
    timestamp = new Date();  //this is when the fitting started
    fittingDate = new Date();  //update to time fitting is completed
    email = '';
    fullName = '';
    firstName = '';
    lastName = '';
    password = '';
    fitterId = 0;
    fitterEmail = '';
    hand = '' as PreferenceHand;
    handicap = '' as PreferenceHandicap;
    //the origX vars are use to know the initial golfer selections so we can compare then to any changes made on the Why Grinds page
    origCourseConditions = '' as PreferenceConditions;
    origBunkerConditions = '' as PreferenceConditions;
    origConfidence = '' as PreferenceConfidence;
    //these are the fields that will be used for all calculations as well as updated on the Why Grinds page
    courseConditions = '' as PreferenceConditions;
    bunkerConditions = '' as PreferenceConditions;
    confidence = '' as PreferenceConfidence;
    pwLoft = '' as Loft;
    highestLoft = '' as Loft;
    recommendedLofts = [] as Loft[];  //lofts we recommend
    selectedLofts = [] as LoftShots[];  //lofts golfer chose, including how he/she ranked them
    loftsForFitting = [] as LoftForFitting[];   //the lofts being fitted and the practice shots taken for each loft
    grindRecommendations = [] as GrindLookup.LoftGrindRecommendation[];  //all the grinds for every loft, the percent match and if golfer chose it
    fittingNotes = '';
    orderId = '';  //fitting id. created when golfer is instantiated so we can track it using GTM
    orderStatus = 'incomplete' as OrderStatus;
    orderEvents = [] as GolferOrderEvent[];
    //shotHistory stores the entire fitting json object and sends to the back-end server upon completion
    //once saved on the back-end server it can be removed from the golfer object to conserve space in the browser's indexed_db
    enhancedFittingData = [] as EnhancedFittingData[];
    phone = "";
    smsOptIn = false;
    consentDataCollection = "";
    consentDataThirdparty = "";
    consentDataInternational = "";
}

export class GolferOrderEvent {
    constructor(public datetime = new Date(), message = "") { }
}

